import { render, staticRenderFns } from "./ProjectFeedback.vue?vue&type=template&id=3aa3ea5d&scoped=true&"
import script from "./ProjectFeedback.vue?vue&type=script&lang=js&"
export * from "./ProjectFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFeedback.vue?vue&type=style&index=0&id=3aa3ea5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3ea5d",
  null
  
)

export default component.exports